import React from 'react';
import {
	useSelector,
} from 'react-redux';

import GraphQL from '~/types/graphql';

import useCreateExport from '~/hooks/useCreateExport';
import useEnabledWebsiteColumnsList from '~/hooks/useEnabledWebsiteColumnsList';
import useWebsiteId from '~/hooks/useWebsiteId';

import {
	getFilter,
} from '~/model/pages';

import {
	filterSelector,
	sortBySelector,
} from '~/state/ui/selectors';



function useExportPages(totalFilteredPages: number | null) {
	const websiteId = useWebsiteId();

	const createExport = useCreateExport(websiteId);
	const enabledWebsiteColumnsList = useEnabledWebsiteColumnsList();
	const filter = useSelector(filterSelector);
	const sortBy = useSelector(sortBySelector);

	const isLarge = totalFilteredPages !== null && totalFilteredPages >= 200000;

	return React.useCallback(
		async (format: GraphQL.ExportFormat) => {
			const exportData = await createExport({
				criteria: {
					columns: enabledWebsiteColumnsList.toArray(),
					filter: getFilter(filter),
					sortBy: sortBy.toJS(),
				},
				type: GraphQL.ExportType.Pages,
				format,
			});

			return {
				...exportData,
				isLarge,
			};
		},
		[
			createExport,
			enabledWebsiteColumnsList,
			filter,
			isLarge,
			sortBy,
		],
	);
}



export default useExportPages;
